export const TABS = {
  COMMENTS: 'comments',
  TASKS: 'tasks',
  CALENDAR: 'calendar',
  APPROVALS: 'approvals',
  COPILOT: 'copilot'
};
export const VALUES_OF_TABS = Object.values(TABS);